import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const ReenrollmentFormForAdminQuery = graphql.persisted(
  "ReenrollmentFormForAdmin",
  graphql(`
    query ReenrollmentFormForAdmin($familyEnrollmentId: String!) {
      reenrollmentFormForAdmin(familyEnrollmentId: $familyEnrollmentId) {
        familyEnrollment {
          id
          state
          enrollmentKind
          family {
            id
            name
          }
          studentEnrollments {
            id
            state
            gradeLevel
            person {
              id
              firstName
              lastName
            }
          }
        }
        formData
        formMetadata
        formAnswers
        formState
        schoolYearName
        tuitionOptions
        paymentOptions
        gradeLevels
        submittedAt
      }
    }
  `)
);

export { ReenrollmentFormForAdminQuery };

export function useReenrollmentFormForAdmin(familyEnrollmentId: string | undefined, skip?: boolean) {
  return useQuery(ReenrollmentFormForAdminQuery, {
    variables: { familyEnrollmentId: familyEnrollmentId! },
    skip: !familyEnrollmentId || skip,
  });
}
